import React, { PropTypes, PureComponent } from 'react';
import { commonPropTypes, eventTypes } from '../../util/constants';
import cx from 'classnames';
import { Icon } from 'react-fast-ui';
import BasketballIcon from '../BasketballIcon';
import _ from 'underscore';
import RecruitAppointment from '../../../res/Recruit_Appt_Icon.png';
import TourneyAppointment from '../../../res/Tourney_Appt_Icon.png';
import SchoolGame from '../../../res/School_Game_Icon.png';
import TourneyGame from '../../../res/Tourney_Game_Icon.png';

const RECRUIT_APPT = (
  <img src={RecruitAppointment} style={{ height: 15, verticalAlign: 'middle' }}/>
);

const TOURNEY_APPT = (
  <img src={TourneyAppointment} style={{ height: 20, verticalAlign: 'middle' }}/>
);

const TOURNEY_GAME = (
  <img src={TourneyGame} style={{ height: 15, verticalAlign: 'middle' }}/>
);

const SCHOOL_GAME = (
  <img src={SchoolGame} style={{ height: 15, verticalAlign: 'middle' }}/>
);

const DEFAULT_CIRCLE_COLOR = 'mint-green';
const PIXEL_SIZES = {
  sm: 8,
  '1x': 12,
  lg: 16,
  '2x': 24,
  '3x': 36,
  '4x': 48,
  '5x': 60
};

export default class EventIcon extends PureComponent {
  static propTypes = {
    event: commonPropTypes.EVENT_SHAPE.isRequired,
    flagged: PropTypes.bool,
    userId: PropTypes.string,
    size: PropTypes.oneOf([ '1x', 'lg', '2x', '3x', '4x', '5x' ])
  };

  defaultProps = {
    flagged: false,
    userId: null,
    size: '1x'
  };

  render() {
    const { className, event, flagged, size, userId, schedule } = this.props;

    switch (event.eventType) {
      case eventTypes.RECRUIT_APPOINTMENT:
        let color;
        if (userId) {
          const userData = _.findWhere(event.accountUserEventData, aued => aued.userId === userId);
          color = userData && userData.color ? { color: `#${userData.color}` } : null;
        }

        return (schedule ? RECRUIT_APPT :
            <Icon
              className={cx(!color ? `color-${DEFAULT_CIRCLE_COLOR}` : null, className)}
              style={color} name="circle"
              size={size}
            />
        );
      case eventTypes.TOURNEY_APPOINTMENT:
        let colorStyle;
        if (userId) {
          const userData = _.findWhere(event.accountUserEventData, aued => aued.userId === userId);
          colorStyle = userData && userData.color ? { color: `#${userData.color}` } : null;
        }

        return (schedule ? TOURNEY_APPT :
          <Icon
            className={cx(!colorStyle ? `color-${DEFAULT_CIRCLE_COLOR}` : null, className)}
            style={colorStyle} name="circle"
            size={size}
          />
        );

      case eventTypes.SCHOOL_GAME:
        if (event.tourney) {
          return (
            schedule ? TOURNEY_GAME :
              <Icon className={cx(`color-${flagged ? 'warning' : 'fastmodel-gray'}`, className)} name="trophy"
                size={size}/>
          );
        } else {
          return schedule ? SCHOOL_GAME : <BasketballIcon className={className} size={PIXEL_SIZES[ size ]}/>;
        }

      case eventTypes.GAME:
        return (
          <Icon className={cx(`color-${flagged ? 'warning' : 'fastmodel-gray'}`, className)} name="trophy"
            size={size}/>
        );

      default:
        return <Icon className={cx(`color-${DEFAULT_CIRCLE_COLOR}`, className)} name="circle" size={size}/>;
    }
  }
}



// WEBPACK FOOTER //
// ./src/js/components/event/EventIcon.jsx